/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import Divider from 'material-ui/Divider'

import 'resources/styles/card/Card.css'

const CardTitle = (props) => (
  <div style={{position: 'relative'}}>
    <h2 className={'CardTitle' + (props.rightIcon ? ' inline' : '')}>
      {props.children}
    </h2>
    {
      props.subTitle
        ? <h3 className={'CardSubTitle' + (props.rightIcon ? ' inline' : '')}>
          {props.subTitle}
        </h3>
        : null
    }

    {
      props.actions
        ? <div className='CardAction'>{props.actions}</div>
        : null
    }

    {
      props.rightIcon
        ? <div className='CardRightIcon' onClick={props.rightIconClick || undefined}>{props.rightIcon}</div>
        : null
    }
    <Divider />
  </div>
)

export default CardTitle



// WEBPACK FOOTER //
// ./src/generic/card/CardTitle.js